import { createFileRoute } from '@tanstack/react-router';
import { CostGroupsSettingsPage } from '../components/CostGroupsSettingsPage';

export const Route = createFileRoute('/settings/cost-groups/employee-cost-group')({
  component: () => <CostGroupsSettingsPage section="employee-assignments" />,
});
